import { all } from 'redux-saga/effects';

import { submitIncidentSaga } from './submitIncident';

export default function* () {
    yield all([submitIncidentSaga()]);
}
